import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { GetWithdrawalMethodResponse } from '../../../Api/CRM/Responses/WithdrawalMethodResponse';
import axios from '../../services/MyAxios';

import WithdrawalMethodDetails from './WithdrawalMethodDetails';

import ActionButton from 'crm/elements/ActionButton';
import { PERMISSION } from 'crm/helpers/Permissions';

type Params = {
    id: string;
};

function WithdrawalMethodShow() {
    const { id } = useParams<Params>();
    const [withdrawalMethod, setWithdrawalMethod] = useState<GetWithdrawalMethodResponse | {}>({});
    const url = `/crea/api/withdrawal_method/${id}`;

    useEffect(() => {
        getWithdrawalMethods();
    }, []);

    function getWithdrawalMethods() {
        axios.get(url).then((response) => {
            setWithdrawalMethod(response.data);
        });
    }

    return (
        <div>
            <WithdrawalMethodDetails withdrawalMethod={withdrawalMethod} />

            <ActionButton
                title="Edit"
                url={`/withdrawal_methods/${id}/edit`}
                permissions={[PERMISSION.UPDATE_WITHDRAWAL_METHOD]}
            />
        </div>
    );
}

export default WithdrawalMethodShow;
